import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { brandModels } from '../data/mockData';
export function Layout() {
  const location = useLocation();
  const isCampaign = location.pathname === '/campaign' || location.pathname === '/';
  // Shared State
  const [activeBrand, setActiveBrand] = useState<string>('Toyota');
  const [activeMarkets, setActiveMarkets] = useState<string[]>([]);
  // Campaign State
  const [activeModel, setActiveModel] = useState<string>('Yaris Cross');
  const [activeType, setActiveType] = useState<string | null>('Tactical');
  const [activeYears, setActiveYears] = useState<string[]>([]);
  // Social State
  const [activeContentType, setActiveContentType] = useState<string | null>(null);
  const [socialYears, setSocialYears] = useState<string[]>(['2026']);
  useEffect(() => {
    const models = brandModels[activeBrand];
    if (models && models.length > 0 && !models.includes(activeModel)) {
      setActiveModel(models[0]);
    }
  }, [activeBrand, activeModel]);
  const context = isCampaign ? {
    activeBrand,
    activeMarkets,
    activeModel,
    activeType,
    activeYears
  } : {
    activeBrand,
    activeMarkets,
    activeContentType,
    socialYears
  };
  return <div className="min-h-screen bg-slate-50 text-foreground font-sans" data-id="element-97">
      <div className="max-w-[1600px] mx-auto p-4 md:p-6 lg:p-8" data-id="element-98">
        <div className="mb-6 lg:mb-8" data-id="element-99">
          <h1 className="text-2xl md:text-3xl font-bold text-foreground tracking-tight" data-id="element-100">
            {isCampaign ? 'Campaign Analytics' : 'Social Analytics'}
          </h1>
          <p className="text-sm md:text-base text-muted-foreground mt-1" data-id="element-101">
            Marketing Dashboard
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8" data-id="element-102">
          <Sidebar isCampaign={isCampaign} activeBrand={activeBrand} setActiveBrand={setActiveBrand} activeMarkets={activeMarkets} setActiveMarkets={setActiveMarkets}
        // Campaign props
        activeModel={activeModel} setActiveModel={setActiveModel} activeType={activeType} setActiveType={setActiveType} activeYears={activeYears} setActiveYears={setActiveYears}
        // Social props
        activeContentType={activeContentType} setActiveContentType={setActiveContentType} socialYears={socialYears} setSocialYears={setSocialYears} data-id="element-103" />

          <main className="flex-1 flex flex-col gap-6 lg:gap-8 min-w-0" data-id="element-104">
            <Outlet context={context} data-id="element-105" />
          </main>
        </div>
      </div>
    </div>;
}